import InputNumber from './input-number';

export default InputNumber;
export type * from './types';
